const isHavePartner = document.getElementById("isHavePartner") as HTMLInputElement;
const notHavePartner = document.getElementById("notHavePartner") as HTMLInputElement;
const isOwnedHome = document.getElementById("isOwnedHome") as HTMLInputElement;
const notOwnedHome = document.getElementById("notOwnedHome") as HTMLInputElement;
const isStillLive = document.getElementById("isStillLive") as HTMLInputElement;
const notStillLive = document.getElementById("notStillLive") as HTMLInputElement;
const isHavePartnerHomeCare = document.getElementById("isHavePartnerHomeCare") as HTMLInputElement;
const notHavePartnerHomeCare = document.getElementById("notHavePartnerHomeCare") as HTMLInputElement;


if (isHavePartner){
    isHavePartner.addEventListener("click", hasPartner);
}

if (notHavePartner){
    notHavePartner.addEventListener("click", noPartner);
}

if (isOwnedHome){
    isOwnedHome.addEventListener("click", owned);
}

if (notOwnedHome){
    notOwnedHome.addEventListener("click", notOwned);
}

if (isStillLive){
    isStillLive.addEventListener("click", still);
}

if (notStillLive){
    notStillLive.addEventListener("click", notStill);
}

if (isHavePartnerHomeCare){
    isHavePartnerHomeCare.addEventListener("click", hasPartnerHomeCare);
}


if (notHavePartnerHomeCare){
    notHavePartnerHomeCare.addEventListener("click", hasNotPartnerHomeCare);
}

function hasPartnerHomeCare() {
    document.getElementById('hasPartnerHomeCare').style.display ='block';
}

function hasNotPartnerHomeCare() {
    document.getElementById('hasPartnerHomeCare').style.display ='none';
}

function hasPartner() {
    document.getElementById('hasPartner').style.display ='inline-flex';
}

function noPartner() {
    document.getElementById('hasPartner').style.display ='none';
}

function owned() {
    document.getElementById('ownedHome').style.display ='block';
    if(notStillLive.checked){
        document.getElementById('notLive').style.display ='block';
    }
    else {
        document.getElementById('notLive').style.display ='none';
    }
}

function notOwned() {
    document.getElementById('ownedHome').style.display ='none';
    document.getElementById('notLive').style.display ='none';
}

function notStill() {
    document.getElementById('notLive').style.display ='block';
}

function still() {
    document.getElementById('notLive').style.display ='none';
}



export default {};
